<script lang="ts" setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useFlowRouter } from '@/features/flow/Flow';
import { useRtl } from '@/shared/composables';
import { ArrowLeftIcon } from '@/shared/ui/icons';
import FlowHeaderLogotype from './FlowHeaderLogotype.vue';
import ProgressBar from './ProgressBar.vue';

const { url = '/', showArrowBack = true } = defineProps<Props>();

const emit = defineEmits<{ (e: 'goBack'): void }>();

const { isRtl } = useRtl();

interface Props {
  url?: string;
  showArrowBack?: boolean;
}

const flowRouter = useFlowRouter();

const { currentStep } = flowRouter;
const prevStepIdx = computed(() => currentStep.value.index - 1);
const stopFlowProcess = ref(false);
const progressBarTextOn = ref(!!flowRouter.routeMeta.value.progressBarTextOn);

const route = useRoute();
watch(
  () => route.path,
  () => {
    stopFlowProcess.value = !!flowRouter.routeMeta.value.stopFlowProcess || !!flowRouter.routeMeta.value.isResultPage;
    progressBarTextOn.value = !!flowRouter.routeMeta.value.progressBarTextOn;
  },
);

onBeforeMount(() => {
  stopFlowProcess.value = !!flowRouter.routeMeta.value.stopFlowProcess || !!flowRouter.routeMeta.value.isResultPage;
});
</script>

<template>
  <div class="flow-widget__header">
    <div class="flow-widget__header-top">
      <div
        v-if="showArrowBack"
        class="flow-widget__header-return"
        :class="{ 'flow-widget__header-return--rtl': isRtl }"
      >
        <ArrowLeftIcon @click="emit('goBack')" />
      </div>
      <FlowHeaderLogotype :url="url" />
    </div>
    <ProgressBar
      v-if="!stopFlowProcess"
      :steps="flowRouter.steps"
      :step="currentStep.index"
      :from-step="prevStepIdx"
      :step-text-on="progressBarTextOn"
    />
  </div>
</template>

<style lang="scss">
@use '@styles/utils' as *;

.flow-widget__header {
  &-top {
    display: flex;
    justify-content: center;
    align-items: center;

    // padding-top: 28px;
    // padding-bottom: 40px;
    max-width: $flow-width;
    margin-inline: auto;
    position: relative;
  }

  &-return {
    cursor: pointer;
    position: absolute;
    inset-inline-start: 0;

    @include transition;

    &:hover {
      opacity: 0.7;
    }

    &--rtl {
      transform: scale(-1);
    }
  }

  @include mobile-flow {
    padding-top: 13px;
    padding-bottom: 32px;
    margin-inline: 24px;
  }
}
</style>
